import { render, staticRenderFns } from "./broseData.vue?vue&type=template&id=15321e72&scoped=true&"
import script from "./broseData.vue?vue&type=script&lang=js&"
export * from "./broseData.vue?vue&type=script&lang=js&"
import style0 from "./broseData.vue?vue&type=style&index=0&id=15321e72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15321e72",
  null
  
)

export default component.exports